<script lang="ts">
  import { Select as SelectPrimitive, type WithoutChild } from "bits-ui";
  import ChevronDown from "lucide-svelte/icons/chevron-down";
  import { cn } from "@/helpers/tw-utils.js";

  let {
    ref = $bindable(null),
    class: className,
    children,
    ...restProps
  }: WithoutChild<SelectPrimitive.TriggerProps> = $props();
</script>

<SelectPrimitive.Trigger
  bind:ref
  class={cn(
    "flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
    className
  )}
  {...restProps}>
  {@render children?.()}
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <mask
        id="mask0_6716_17500"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6716_17500)">
        <path
          d="M9.60433 11.6042L6.64352 8.64179C6.60267 8.60095 6.57204 8.55668 6.55162 8.509C6.5312 8.46133 6.521 8.41319 6.521 8.36458C6.521 8.26736 6.55537 8.18229 6.62412 8.10938C6.69287 8.03646 6.7835 8 6.896 8H13.1043C13.2168 8 13.3075 8.0375 13.3762 8.1125C13.445 8.1875 13.4793 8.275 13.4793 8.375C13.4793 8.38889 13.4385 8.47758 13.3568 8.64106L10.396 11.6042C10.3404 11.6597 10.2779 11.7014 10.2085 11.7292C10.1391 11.7569 10.0696 11.7708 10.0002 11.7708C9.93072 11.7708 9.86127 11.7569 9.79183 11.7292C9.72239 11.7014 9.65989 11.6597 9.60433 11.6042Z"
          fill="#BEBEBE" />
      </g>
    </svg>
  </div>
</SelectPrimitive.Trigger>
